import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "prompt-content__tips" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "prompt-content__tips--text" }, /*#__PURE__*/_toDisplayString('你已退出登录。登录账号，以访问更多内容。'))
], -1)
const _hoisted_2 = { class: "prompt-content__button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 暂不登录 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 立即登录 ")

import { NButton } from 'naive-ui'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'

export default /*#__PURE__*/_defineComponent({
  __name: 'notLoginPublic',
  setup(__props) {

const { onLogin, onNotYetLogin } = useAccountChange()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NButton), { onClick: _unref(onNotYetLogin) }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(NButton), {
        type: "primary",
        onClick: _unref(onLogin),
        class: "prompt-content__button--default"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})